import { Reveal } from "./Reveal";
import { LiteVideo } from "./LiteVideo";
import { CtaButton } from "./CtaButton";
import { VIDEOS } from "../../data/content";

export const Charity = () => (
  <section data-testid="charity-section" className="bg-[var(--cream)] py-24 md:py-32">
    <div className="mx-auto max-w-5xl px-5">
      <Reveal className="mx-auto max-w-3xl text-center">
        <p className="text-[11px] font-semibold uppercase tracking-[0.42em] text-[var(--moss-dark)]">Projetos caritativos</p>
        <h2 data-testid="charity-title" className="font-display mt-5 text-3xl leading-tight text-[var(--forest)] md:text-5xl">
          Você adquirindo acesso à nossa comunidade, estará <em className="text-[var(--moss-dark)]">doando e colaborando</em> com nossos projetos sociais numa ação caritativa
        </h2>
      </Reveal>
      <Reveal delay={0.15} className="mt-14">
        <LiteVideo id={VIDEOS.charity} title="Caridade — Projetos caritativos" testId="charity-video" />
      </Reveal>
      <Reveal className="mt-12 flex justify-center">
        <CtaButton testId="charity-cta-vitalicio" light />
      </Reveal>
    </div>
  </section>
);
